import { Timestamp } from 'firebase/firestore';

export const STORY_STATUSES = {
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
  PUBLISHED: 'published',
  EXPIRED: 'expired',
  UNPUBLISHED: 'unpublished',
} as const;

export interface StoryChapter {
  id?: string;
  difficulty: string;
  chapterIntroduction: string;
  type: 'static' | 'video';
  url: string;
  lowQualityImageUrl: string | null;
  highQualityImageUrl: string | null;
  iconUrl: string;
  videoIconUrl: string | null;
  staticPreviewPlaceholderUrl: string | null;
  videoPreviewUrl: string | null;
  chapterNumber: number;
  originalUrl?: string;

  _meta: {
    originalResolution?: string;
    resolution?: string;
    highQualityResolution?: string | null;
    lowQualityResolution?: string | null;
  };
}
export type StoryChapterMediaFieldsType =
  | 'url'
  | 'lowQualityImageUrl'
  | 'highQualityImageUrl'
  | 'iconUrl'
  | 'videoIconUrl'
  | 'videoPreviewPlaceholderUrl'
  | 'videoPreviewUrl';

export interface Story {
  id?: string;
  title: string;
  storyAbout: string;
  storyEnd: string;
  status: typeof STORY_STATUSES[keyof typeof STORY_STATUSES];
  publishDate: Date | Timestamp | null;
  expirationDate: Date | Timestamp | null;
  imageUrl: string;
  soundtrackUrl: string | null;
  entryFee: Record<string, number>;
  reward: Record<string, number>;
  publishedAt: Date | Timestamp | null;
  createdBy: string | null;
  createdAt: Date | Timestamp;
  chapters?: StoryChapter[];
  titleImageUrl: string;
  publisher: string;
}

export type StoryMediaFieldsType = 'imageUrl' | 'soundtrackUrl';
